import React from 'react';
import Chip from './Chip';
import { ChipsIndicator, ChipsRow } from './styles';
import { FilterField, FilterValues } from './types';
import { formatDateRangeLabel } from './fields/dateRangePresets';
import { Icon } from 'semantic-ui-react';

export type ActiveFilterChipsProps = {
  fields: FilterField[];
  values: FilterValues;
  onRemove: (field: FilterField) => void;
};

const getChipValue = (field: FilterField, values: FilterValues): string | undefined => {
  if (field.getDisplayValue) {
    return field.getDisplayValue(values);
  }

  if (field.kind === 'select') {
    const option = field.options.find(opt => opt.value === values[field.name]);
    return option?.label || values[field.name];
  }

  if (field.kind === 'dateRange') {
    return formatDateRangeLabel(values[field.startName], values[field.endName]);
  }

  if (field.kind === 'checkbox') {
    return values[field.name] ? 'Sim' : undefined;
  }

  if (field.kind === 'search') {
    return values[field.argumentName || 'argument'];
  }

  const raw = values[field.name];
  if (raw === null || raw === undefined || raw === '') return undefined;
  return String(raw);
};

const ActiveFilterChips: React.FC<ActiveFilterChipsProps> = ({
  fields,
  values,
  onRemove
}) => {
  if (!fields.length) return null;

  return (
    <ChipsRow>
      <ChipsIndicator>
        <Icon name="sliders horizontal" />
        <Icon name="arrow right" size="small" />
      </ChipsIndicator>
      {fields.map(field => {
        const value = getChipValue(field, values);
        if (!value) return null;
        return (
          <Chip
            key={field.name}
            label={field.label}
            value={value}
            onRemove={() => onRemove(field)}
          />
        );
      })}
    </ChipsRow>
  );
};

export default ActiveFilterChips;
